// temporary: flip to true to re-enable SMS (campaigns AND flows). Mirrors the
// backend kill switch `campaign_lifecycle.SMS_CAMPAIGNS_ENABLED` — keep both
// in sync. While false, existing SMS records stay viewable/deletable/pausable
// but can't be sent, scheduled, resumed or set live.
export const SMS_CAMPAIGNS_ENABLED: boolean = false

export const SMS_UNAVAILABLE_NOTE = 'SMS campaigns are temporarily unavailable.'

// True when launch-type actions must be hidden for a record on this channel.
export const isSmsLaunchBlocked = (channel: string | null | undefined) =>
  !SMS_CAMPAIGNS_ENABLED && channel?.toLowerCase() === 'sms'
